var $b17590f21009e0d3$exports = {};
// homework 09 week
const $b17590f21009e0d3$var$numbers = [
    1,
    2,
    3,
    4,
    5
];
const $b17590f21009e0d3$var$sum = (numbers)=>{
    let total = 0;
    for (let partNumber of numbers)total = total + partNumber;
    return total;
};
console.log($b17590f21009e0d3$var$sum($b17590f21009e0d3$var$numbers));


//# sourceMappingURL=index.d59f70f6.js.map
